<div class="content__wrapper">
  @if (showSidebar) {
    <app-nav-menu
      [env]="environment"
      [firstName]="userLite?.firstName || ''"
      [lastName]="userLite?.lastName || ''"
      [isLoggedIn]="isLoggedIn"
      [userToken]="userToken"
      appTitle="Sierra Item"
      (logout)="onLogout()"
      [menuItems]="menuItems"
      [sites]="sites"
      [selectedSiteId]="selectedSiteId"
      (siteChanged)="onSiteChanged($event)"
    />
  }
  <p-confirmdialog key="main" />
  <p-toast key="main" />

  <div class="cs-shell">
    @if (showSidebar) {
      <csl-main-header />
    }
    <router-outlet></router-outlet>
  </div>
</div>
<p-toast position="bottom-right" key="unauthorized"></p-toast>
<csl-environment-indicator [envType]="environment" />
